import checkout from "./form";

const {
  formField: {
    taxAgentName,
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    timeSign,
    contractNumber,
    contractDay,
  },
} = checkout;

const initialValues = {
  [taxAgentName.name]: "",
  [certificate.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",
  [contractNumber.name]: "",
  [contractDay.name]: "",
};

export default initialValues;
